import { getWebsocketUrl } from "./api";

class DebuggerService {
  constructor() {
    this.socket = null;
    this.isConnected = false;
    this.messageCallbacks = new Set();
    this.lastError = null;
  }

  async connect() {
    if (this.isConnected) {
      this.lastError = "Already connected to debugger";
      return;
    }

    try {
      const url = await getWebsocketUrl("api/prompt/debugger/ws");     
      this.socket = new WebSocket(url);
      
      this.socket.onopen = () => {
        this.isConnected = true;
      };

      this.socket.onmessage = (event) => {
        const message = JSON.parse(event.data);
        this.messageCallbacks.forEach(callback => callback(message));
      };

      this.socket.onclose = () => {
        this.isConnected = false;
      };

      this.socket.onerror = (error) => {
        this.lastError = "WebSocket error: " + error;
      };
    } catch (error) {
      this.lastError = "Failed to connect to debugger: " + error;
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.close();
    }
  }

  sendMessage(message) {
    if (this.isConnected) {
      this.socket.send(JSON.stringify(message));
    } else {
      console.error("Not connected to debugger");
    }
  }

  onMessage(callback) {
    this.messageCallbacks.add(callback);
    return () => this.messageCallbacks.delete(callback);
  }

  isConnected() {
    return this.isConnected;
  }

  getLastError() {
    return this.lastError;
  }
}

const debuggerService = new DebuggerService();

export default debuggerService;